<ng-container>
  <div class="card-container">
    <ion-grid
      class="top-section top-section-color ion-text-center"
      [class.top-section-color]="!greyscale"
      [class.top-section-greyscale]="greyscale">
     <cdn-img size="md" class="corner-topological-lines"
      [src]="'/assets/img/plan-card/' + topologicalLinesAssetFileName"></cdn-img>
      <ion-row>
        <ion-col>
          <ion-text [color]="greyscale ? 'light' : 'tertiary'">
            <h2>{{ displayName }}</h2>
          </ion-text>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-text color="light">
            <span>Perfect for&#32;</span>
          </ion-text>
          <ion-text color="secondary">
            <span>{{ numberOfPeople }} people</span>
          </ion-text>
        </ion-col>
      </ion-row>

      @if (priceWithoutDiscount !== price) {
        <ion-row>
          <ion-col class="ion-no-padding-bottom">
            <ion-text class="price" [color]="greyscale ? 'primary' : 'medium'">
              <span class="price-without-discount">
                ${{ priceWithoutDiscount }}
                <div class="price-without-discount-line"></div>
              </span>
            </ion-text>
          </ion-col>
        </ion-row>
      }

      <ion-row class="ion-text-center">
        <ion-col class="ion-no-padding-top">
          @if (!price) {
            <ion-skeleton-text></ion-skeleton-text>
          }
          @if (price) {
            <ion-text class="price" color="white">
              <span class="price-dollar">$</span>
              <span class="price-number">{{ price }}</span>
              <sup class="price-frequency">/{{ displayFrequency }}</sup>
            </ion-text>
          }
        </ion-col>
      </ion-row>

      @if (frequency === 'annual' && alwaysShowMonthlyPrice) {
        <ion-row>
          <ion-col class="ion-no-padding">
            <ion-text class="billed-annually">* Billed annually</ion-text>
          </ion-col>
        </ion-row>
      }

      @if (showActionButton) {
        <ion-row>
          <ion-col push="3" size="6">
            <ion-button
              type="submit"
              class="full-width ion-margin-bottom"
              color="secondary"
              size="large"
              (click)="goToNextPage()">
              Select
            </ion-button>
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  </div>
</ng-container>
